import React from 'react';
import {ActiveFilter} from '../../../services/games-filter/games-filter.service.interface';
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import {observer} from 'mobx-react';
import {FilterLinkListComponent} from '../filter-link-list/filter-link-list.component';
import {FiltersGamesMobilePopupBox} from "./boxes/popup/filters-games-mobile-popup.box";
import {FiltersMobileButtonsBox} from "./boxes/popup/menu/filters-mobile-buttons.box";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import {GroupFiltersListComponent} from "../group-filters-list/group-filters-list.component";
import { ModalDialogActionsComponent } from '../../modal-dialog/modal-dialog-actions.component';


export interface FiltersGamesListMobileComponentState {
    filters: ActiveFilter[]
}

export interface FiltersGamesListMobileComponentProps {
    dialogHandler: IModalDialogHandler;
}

@observer
export class FiltersGamesListMobileComponent extends OrbitComponentWithState<FiltersGamesListMobileComponentProps, FiltersGamesListMobileComponentState> {
    state: FiltersGamesListMobileComponentState = {
        filters: []
    };

    componentDidMount() {
        super.componentDidMount();
        this.setState({
            filters: this.services.gamesFilter.currentFilters.map<ActiveFilter>(filter => {
                return {...filter};
            })
        });
    }


    private _closePopup = () => {
        this.props.dialogHandler.close();
    };

    private _toggleFilter = (filterToToggle: ActiveFilter) => {
        const newFilters = this.state.filters.map(filter => {
            if (filter.id === filterToToggle.id) {
                return {...filterToToggle, on: !filterToToggle.on}
            } else {
                return filter;
            }
        });

        this.setState({filters: newFilters});
    };

    private _applyFilters = () => {
        const checkedFiltersIds = this.state.filters.filter(filter => filter.on)
            .map(filter => filter.id);

        this.services.gamesFilter.applyMultipleFilters(checkedFiltersIds);
        this.services.analytics.sendAnalytics("Navigation", this.services.routing.currentRoute.data.arenaType, checkedFiltersIds.join(','));

        this._closePopup();
    };

    private _clearFilters = () => {
        const newFilters = this.state.filters.map(filter => {
            return {...filter, on: false}
        });

        this.setState({filters: newFilters}, () => this._applyFilters());
    };

    private _renderPopupButtons() {
        return (<FiltersMobileButtonsBox className={'cy-filters-games-buttons'}>
            <ModalDialogActionsComponent primaryAction={{
                className: 'cy-apply-filters-button',
                text: this.services.translation.translate('APPLY'),
                onClick: this._applyFilters
            }} secondaryAction={{
                className: 'cy-clear-filters-button',
                text: this.services.translation.translate('CLEAR_ALL'),
                onClick: this._clearFilters,
                useWarningPreset: true
            }} buttonsOnSeparateLines={this.services.mediaQuery.lAndBelow} />
        </FiltersMobileButtonsBox>);
    }

    render() {
        if (!this.services.device.isMobile) {
            return null;
        }

        if (this.services.gamesFilter.currentFilters.length === 0) {
            return null;
        }

        return (
            <FiltersGamesMobilePopupBox className={'cy-filters-games-mobile'}>
                {this.services.gamesFilter.supportFiltersV2() ?
                    <GroupFiltersListComponent
                        filtersGroup={[{
                            text: 'FILTER_GROUP_VENDOR_TYPE',
                            filters: this.state.filters,
                            isMultiSelect: true
                        }]}
                        onToggle={this._toggleFilter}/>
                    :
                    <FilterLinkListComponent filters={this.state.filters} onToggle={this._toggleFilter}/>
                }
                {this._renderPopupButtons()}
            </FiltersGamesMobilePopupBox>
        )
    }
}

